/* tslint:disable */
// @ts-nocheck
/**
 * Financial account sync status (EDG-529 companion).
 *
 * Hand-written in the swagger-typescript-api shape so it plugs into the
 * OspApiClientProvider factory pipeline (HttpClient reused from the
 * generated AccountReadsApi — same secure-request pipeline and headers).
 *
 * Contract (shared across mixture/opensocial/web — do not drift):
 * GET /v2/financial/sync-status (owner from auth context, never a query param)
 * {"accounts":[{"account_id":"...","state":"SYNCING|COMPLETE|FAILED","updated_at":123}],
 *  "summary":"SYNCING|COMPLETE|IDLE","synced_count":2,"total_count":3}
 * summary: no valid records = IDLE; any valid SYNCING = SYNCING; else COMPLETE (settled).
 */

import { HttpClient } from "./AccountReadsApi";

export interface FinancialSyncStatusAccount {
  account_id: string;
  state: "SYNCING" | "COMPLETE" | "FAILED" | "UNKNOWN";
  updated_at: number;
  /** Backend directory join field (e.g. INVESTMENT/DEPOSITORY/CREDIT/LOAN). Absent on undeployed backends — gate falls back to all-accounts completion. */
  account_type?: string;
}

export interface FinancialSyncStatusResponse {
  accounts: FinancialSyncStatusAccount[];
  summary: "SYNCING" | "COMPLETE" | "IDLE";
  synced_count: number;
  total_count: number;
}

export class FinancialSyncStatusClient<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  financialSyncStatus = {
    /**
     * @tags financialSyncStatus
     * @name GetSyncStatus
     * @summary Per-account sync state for the current owner
     * @request GET:/financial/sync-status
     * @secure
     */
    getSyncStatus: (params: RequestParams = {}) =>
      this.request<FinancialSyncStatusResponse, any>({
        path: `/financial/sync-status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
